import React from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import LinkIcons from './LinkIcons';
import {oneHalf} from '@xpertdox_js/xdstyle';
import { trackActivity } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext'
import { InstanceContext } from '../../InstanceContext'

const ConsoleLinks = props => {

  const trialListPrefixIDs = ['xpertTriage', 'triageStudies', 'bulkUploads', 'allTrials', 'studyContacts', 'specialtyContacts', 'addTrials', 'surveyQuestions', 'searchPatients', 'emailRecords', 'studyLocation', 'myPatients', 'getTrials', 'userActivity']; // removed 'customDescription', 'priorityTrials'
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }
  const handleRoute = routeSettings => {
    handleActivityLogUpdate(`ConsoleLinks.handleRoute`)
    props.history.push({
      pathname: (
        trialListPrefixIDs.includes(routeSettings[0])
        ? '/trial_list'
        : ''
      ) + '/' + props.trueInstance + '/' + routeSettings[0],
      state: {
        auth: props.user,
        instance: props.trueInstance,
        title: routeSettings[1].title
      }
    })
  }

  return(
    <div style={styles.clearfix}>
        {Object.keys(props.trialTabs).map((title, i) => {
          return(
            props.trialTabs[title].length > 0
            ? <div key={title} style={props.columns.oneHalf}>
                <h5 style={styles.subTitle}>{title}</h5>
                <ul style={{...styles.list, ...styles.clearfix}}>
                {props.trialTabs[title].map((settings, i) => {
                  return(
                    <li key={settings[0]} style={{...styles.listItem, ...oneHalf, padding: 0}}>
                      <Button
                        styles={styles.link}
                        hoverStyles={styles.linkHov}
                        onClick={handleRoute}
                        clickParam={settings}
                      >
                        <LinkIcons name={settings[0]} size='sm' />
                        <span style={styles.linkText}>{settings[1].title}</span>
                      </Button>
                    </li>

                  )
                })}
                </ul>
              </div>
            : null
          )
        })}
    </div>
  )
}

export default ConsoleLinks;
